export default {
  brand: {
    name: 'VILLAGARAGE',
    tagline: 'Premium Garage Systems',
  },
  nav: {
    home: 'Startseite',
    garage: 'Garagensysteme',
    villa: 'Villaprojekte',
    winter: 'Wintergarten',
    projects: 'Projekte',
    about: 'Über uns',
    contact: 'Kontakt',
    dealer: 'Partnerschaft & Händlerschaft',
    login: 'Mitglieder- / Händler-Login',
    cta: 'Angebot für Ihr Projekt',
  },
  hero: {
    title1: 'Premium Garagensysteme,',
    title2: 'die Ihrer Villa Wert verleihen',
    subtitle: 'Architektonisch zugeschnittene Premium-Garagenlösungen für luxuriöse Villaprojekte und private Villen.',
    cta1: 'Angebot für Ihr Projekt',
    cta2: 'Garagensysteme entdecken',
    small: '1- & 2-Fahrzeug-Systeme • Architekturgetreues Design • Projektbasierte Lösungen',
  },
  s1: {
    title: 'Eine Garage sollte kein nachträglicher Anbau Ihrer Villa sein.',
    text: 'VILLAGARAGE betrachtet die Garage nicht als eigenständige Struktur, sondern als integralen Bestandteil der Architektur der Villa.',
    f1: 'Architekturgetreues Design',
    f2: 'Premium-Erscheinungsbild',
    f3: 'Ganzjähriger Fahrzeugschutz',
  },
  s2: {
    title: 'Dieselbe Villa. Ein anderer Lebensstandard.',
    openTitle: 'Offener Stellplatz',
    openDesc: 'Fahrzeug den Elementen ausgesetzt. Fehlende architektonische Einheit. Kein Mehrwert für das Projekt.',
    garageTitle: 'VILLAGARAGE Premium-Garage',
    garageDesc: 'Fahrzeug ganzjährig geschützt. Integriert sich in die Architektur der Villa. Schafft Premium-Mehrwert.',
    cta: 'Lösung für Ihr Projekt anfragen',
  },
  s3: {
    title: 'Garagensysteme',
    cta: 'Entdecken',
    card1: {
      title: 'Premium-Garage für ein Fahrzeug',
      desc: 'Eine kompakte, elegante und architektonisch zugeschnittene Premium-Garage für ein Fahrzeug.',
    },
    card2: {
      title: 'Premium-Garage für zwei Fahrzeuge',
      desc: 'Eine großzügige, luftige Premium-Garage, die sich nahtlos in Ihre Villa integriert, für zwei Fahrzeuge.',
    },
    card3: {
      title: 'Projektspezifische Garagensysteme',
      desc: 'Maßgeschneiderte Lösungen für Villaprojekte und individuelle Anforderungen.',
    },
  },
  s4: {
    title1: 'Keine zwei Villen sind gleich.',
    title2: 'Ihre Garagen auch nicht.',
    d1: 'Anthrazit-Architektursysteme',
    d2: 'Natürliche Holzdetails',
    d3: 'Architektonische Beleuchtung',
    d4: 'Individuelle Fassadengestaltung',
    d5: '1- & 2-Fahrzeug-Lösungen',
  },
  s5: {
    title: 'Ein Detail, das Villaprojekte vom Standard abhebt',
    subtitle: 'VILLAGARAGE für Bauunternehmen, Projektentwickler und Architekten.',
    b1: 'Projektspezifisches Design',
    b2: 'Integration in die Villenarchitektur',
    b3: 'Struktur für Mehrvillen-Projekte geeignet',
    b4: 'Premium-Projektwahrnehmung',
    b5: 'Einzel- / Doppel-Fahrzeug-Lösungen',
    b6: 'Systemansatz als Alternative zu traditionellen schweren Bauverfahren',
    cta: 'Ihr Villaprojekt einreichen',
  },
  s6: {
    title: 'Lassen Sie Ihr Luxusauto nicht ganzjährig im Freien stehen.',
    text: 'Schaffen Sie einen besser geschützten Premium-Bereich gegen Sonne, Regen, Hagel, Schnee und äußere Einflüsse.',
    cta: 'Ich möchte eine Garage für meine Villa',
  },
  s7: {
    title: 'Ganzheitliche Architekturlösungen für Ihre Villa',
    subtitle: 'Premium-Garage + Wintergarten',
    cta: 'Informationen für mein Projekt anfragen',
  },
  s8: {
    title: 'Wie beginnt Ihr Projekt?',
    step1: 'Teilen Sie Ihren Raum',
    step1d: 'Senden Sie uns die wesentlichen Details zu Ihrer Villa oder Ihrem Projekt.',
    step2: 'Bedarf festlegen',
    step2d: 'Lassen Sie uns Fahrzeugkapazität und Nutzungsszenarien gemeinsam klären.',
    step3: 'Designansatz',
    step3d: 'Lassen Sie uns einen maßgeschneiderten Designansatz für Ihre Architektur entwickeln.',
    step4: 'Angebot',
    step4d: 'Lassen Sie uns Ihnen ein individuelles Angebot basierend auf dem Projektumfang erstellen.',
    step5: 'Umsetzung',
    step5d: 'Nach der Freigabe führen wir die Umsetzung wie geplant durch.',
  },
  s9: {
    title: 'Inspirierende Garagenprojekte',
    filterAll: 'Alle',
    filterSingle: 'Ein Fahrzeug',
    filterDouble: 'Zwei Fahrzeuge',
    filterVilla: 'Villaprojekte',
    filterWinter: 'Wintergarten',
  },
  s10: {
    title: 'Gestalten wir eine individuelle Lösung für Ihre Villa oder Ihr Projekt.',
  },
  form: {
    name: 'Vollständiger Name',
    namePh: 'Ihr vollständiger Name',
    phone: 'Telefon',
    phonePh: '+90 5xx xxx xx xx',
    email: 'E-Mail',
    emailPh: 'beispiel@email.com',
    city: 'Stadt',
    cityPh: 'Ihre Stadt',
    customerType: 'Kundentyp',
    solution: 'Gewünschte Lösung',
    projectStatus: 'Projekt- / Grundstücksstatus',
    message: 'Nachricht',
    messagePh: 'Beschreiben Sie kurz Ihr Projekt...',
    upload: 'Bild-Upload',
    uploadHint: 'Sie können Grundstücks-, Villen- oder Referenzbilder hochladen',
    submit: 'MEIN PROJEKT SENDEN',
    success: 'Ihre Anfrage wurde empfangen. Wir werden uns in Kürze bei Ihnen melden.',
    error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    customer: {
      villaOwner: 'Villabesitzer',
      construction: 'Bauunternehmen',
      developer: 'Projektentwickler',
      architect: 'Architekt',
      investor: 'Investor',
      other: 'Sonstiges',
    },
    solutionOpt: {
      single: 'Garage für ein Fahrzeug',
      double: 'Garage für zwei Fahrzeuge',
      villaProject: 'Villaprojekt',
      winterGarden: 'Wintergarten',
      combined: 'Garage + Wintergarten',
      custom: 'Sonderprojekt',
    },
    status: {
      land: 'Grundstück vorhanden',
      construction: 'Villa im Bau',
      existing: 'Bestehende Villa',
      none: 'Noch kein Grundstück',
      other: 'Sonstiges',
    },
  },
  whatsapp: {
    message: 'Hallo VILLAGARAGE, ich möchte Informationen und ein Angebot für mein Villa- / Garagenprojekt erhalten.',
  },
  mobile: {
    cta: 'Informationen für Ihr Projekt anfragen',
  },
  faq: {
    title: 'Häufig gestellte Fragen',
    q1: 'Kann es auf bestehende Villen angewendet werden?',
    a1: 'Ja. Wir bieten Lösungen sowohl für neu gebaute als auch für bestehende Villen. Bei bestehenden Villen erfolgt eine projektspezifische Umsetzung nach Bewertung von Raum und architektonischer Struktur.',
    q2: 'Gibt es Ein- und Zwei-Fahrzeug-Systeme?',
    a2: 'Ja, unsere Premium-Garagensysteme für ein und zwei Fahrzeuge sind verfügbar. Wir entwickeln auch projektspezifische Mehrfachlösungen.',
    q3: 'Wird für jede Villa dasselbe Modell verwendet?',
    a3: 'Nein. Jedes Projekt wird individuell nach Architektur, Abmessungen und Kundenbedürfnissen gestaltet; es wird kein Standardmodell verwendet.',
    q4: 'Arbeiten Sie an Mehrvillen-Projekten?',
    a4: 'Ja, wir arbeiten bei Mehrvillen-Projekten mit Bauunternehmen und Projektentwicklern zusammen und bieten projektbasierte Sonderlösungen.',
    q5: 'Kann auch ein Wintergarten gebaut werden?',
    a5: 'Ja. Zusätzlich zu Garagensystemen bieten wir Wintergarten- und integrierte Garage + Wintergarten-Lösungen.',
    q6: 'Wie wird der Preis festgelegt?',
    a6: 'Die Preisgestaltung richtet sich nach Abmessungen, Fahrzeugkapazität, architektonischen Details, Materialpräferenzen und Projektumfang.',
    q7: 'Wie kann ich mein Projekt einreichen?',
    a7: 'Sie können das Formular auf unserer Website ausfüllen, uns über WhatsApp (+90 542 799 47 89) erreichen oder eine Nachricht über Instagram (@villagarage90) senden.',
  },
  about: {
    title: 'Über uns',
    text: 'VILLAGARAGE ist eine Marke, die architektonische Lösungen für Premium-Villagaragen und Außenwohnbereiche entwickelt. Sie betrachtet die Garage nicht als eigenständige Struktur, sondern als integralen Bestandteil der Architektur der Villa und verleiht Wohnräumen durch Anthrazit-Systeme, natürliche Holzdetails und individuelle Fassadengestaltung bleibenden Wert. In Zusammenarbeit mit Villabesitzern, Architekten, Bauunternehmern und Projektentwicklern liefert sie auf jede Anforderung zugeschnittene Premium-Lösungen, die in die Architektur integriert sind.',
  },
  final: {
    title: 'Vollenden Sie die Architektur Ihrer Villa mit Ihrer Garage.',
    cta1: 'Angebot für Ihr Projekt',
    cta2: 'Kontakt über WhatsApp',
  },
  roles: {
    member: 'Standardmitglied',
    dealer_a: 'Klasse-A-Händler',
    dealer_b: 'Klasse-B-Händler',
    dealer_c: 'Klasse-C-Händler',
    distributor: 'Vertreter',
    architect: 'Architekt',
    construction: 'Bauunternehmen',
    realtor: 'Immobilienmakler',
    admin: 'Administrator',
  },
  catalog: {
    title: 'Garagensysteme',
    all: 'Alle',
    cat: {
      standard: 'Standardgaragen',
      custom: 'Individuelle Design-Garagen',
      luxury: 'Luxusgaragen',
    },
    tag: {
      new: 'Neu',
      single: 'Einzelwagen',
      double: 'Doppelwagen',
      premium: 'Premium',
      project: 'Projektbezogen',
    },
    capacityLabel: 'Fahrzeugkapazität',
    singleCar: '1 Fahrzeug',
    doubleCar: '2 Fahrzeuge',
    multiCar: 'Mehrere Fahrzeuge',
    quote: 'Angebot anfordern',
    details: 'Details',
    addToCart: 'In den Warenkorb',
    projectQuote: 'Projektbezogenes Angebot erstellen',
    from: 'Ab',
    priceOnRequest: 'Angebot für den Preis anfordern',
    empty: 'In dieser Kategorie sind noch keine Produkte vorhanden.',
    p1: { desc: 'Eine kompakte, elegante und architektonisch zugeschnittene Premium-Garage für ein Fahrzeug.' },
    p2: { desc: 'Eine großzügige, luftige Premium-Garage, die sich nahtlos in Ihre Villa integriert, für zwei Fahrzeuge.' },
    p3: { desc: 'Eine speziell für Ihre Villa entworfene Einzelwagen-Garage, integriert in die Architektur.' },
    p4: { desc: 'Eine individuell gestaltete architektonische Doppelgarage.' },
    p5: { desc: 'Eine Luxus-Villagarage mit Materialien und Details der höchsten Klasse.' },
    p6: { desc: 'Projektbasierte Garagensysteme für Mehrvillen-Projekte.' },
  },
  currency: {
    label: 'Währung',
    planned: 'Bald',
  },
  auth: {
    title: 'Mitglieder- / Händler-Login',
    subtitle: 'Zugang zu Ihrem rollenspezifischen Panel und Preisen.',
    email: 'E-Mail',
    password: 'Passwort',
    submit: 'Anmelden',
    note: 'Die sichere Anmeldung und die rollenbasierte Autorisierung werden aktiv, sobald die Backend-Verbindung hergestellt ist.',
    comingSoon: 'Die Anmeldeebene ist bereit. Dieser Bildschirm wird aktiv, sobald die sichere Backend-Verbindung hergestellt ist.',
    roleInfoTitle: 'Rollenbasierter Zugriff',
    roleInfoText: 'Unterstützt werden Standardmitglied, Klasse-A/B/C-Händler, Vertreter, Architekt, Bauunternehmen, Immobilienmakler und Administrator. Jede Rolle sieht nur die ihr erlaubten Bereiche; die Autorisierung erfolgt serverseitig.',
    applyCta: 'Für Händlerschaft & Partnerschaft bewerben',
    backHome: 'Zurück zur Startseite',
  },
  dealer: {
    badge: 'Partnerschaftsnetzwerk',
    heroTitle: 'Treten Sie dem VILLAGARAGE-Partnerschaftsnetzwerk bei',
    heroSubtitle: 'Bringen Sie VILLAGARAGE Premium-Garagensysteme in der Türkei und auf internationalen Märkten zu Ihren Kunden.',
    heroCta: 'Jetzt bewerben',
    modelsTitle: 'Mitgliedschafts- & Händlermodelle',
    modelsSubtitle: 'Eine Struktur für jede Stufe, vom Einzelkunden bis zum professionellen Händler.',
    cardCta: 'Detaillierte Infos & Bewerbung',
    models: {
      standard: { name: 'Standardmitgliedschaft', desc: 'Basis-Mitgliedschaft für Einzelkunden und reguläre Mitglieder.' },
      a: { name: 'Klasse-A-Händlerschaft', desc: 'Das umfassendste Händlermodell. Rabatte, Kontingent, Kaution und Zahlungsvorteile werden vom Administrator festgelegt.' },
      b: { name: 'Klasse-B-Händlerschaft', desc: 'Ein ausgewogenes Partnerschaftsmodell für mittelgroße Händler.' },
      c: { name: 'Klasse-C-Händlerschaft', desc: 'Ein Einstiegs-Partnerschaftsmodell für neue Händler.' },
    },
    proTitle: 'Professionelle Partnerschaft',
    proSubtitle: 'Ein flexibles Partnerschaftsmodell für Fachleute, die Projekte und Kunden vermitteln.',
    proSectors: 'Architekten • Bauunternehmen • Immobilienmakler • Vertreter',
    partnerCta: 'Partner werden',
    partnersTitle: 'Partnermodelle',
    partners: {
      distributor: 'Vertreter',
      architect: 'Architekt',
      construction: 'Bauunternehmen',
      realtor: 'Immobilienmakler',
      other: 'Anderer Partner',
    },
    partnersNote: 'Ohne Händlerkontingent oder Kaution; jede Gruppe erhält ihren eigenen Rabatt, Preisvorteil und ihre Berechtigungsstufe.',
    termsTitle: 'Klassenspezifische Konditionen',
    termsText: 'Rabatte, Einkaufskontingente, Kautionsbeträge und Zahlungsvorteile werden für jede Händlerklasse separat festgelegt und über das Admin-Panel verwaltet. Diese Werte sind derzeit nicht fixiert.',
    rolesTitle: 'Rollenstruktur',
    rolesSubtitle: 'Jeder Nutzer sieht nur die für seine Rolle erlaubten Bereiche; die Autorisierung erfolgt serverseitig, sobald ein sicheres Backend verbunden ist.',
    form: {
      title: 'Bewerbungsformular',
      subtitle: 'Füllen Sie das untenstehende Formular aus; Ihre Bewerbung wird zur Prüfung entgegengenommen.',
      name: 'Vollständiger Name',
      company: 'Firmenname',
      phone: 'Telefon',
      email: 'E-Mail',
      country: 'Land',
      city: 'Stadt',
      website: 'Webseite',
      instagram: 'Instagram',
      field: 'Tätigkeitsbereich',
      applicationType: 'Bewerbungsart',
      selectPlaceholder: 'Auswählen',
      howToWork: 'Wie möchten Sie mit VILLAGARAGE zusammenarbeiten?',
      messagePh: 'Erzählen Sie es uns kurz...',
      submit: 'Bewerbung senden',
      success: 'Ihre Bewerbung wurde zur Prüfung entgegengenommen.',
      error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    },
  },
  footer: {
    tagline: 'Premium Garage Systems',
    navTitle: 'Menü',
    contactTitle: 'Kontakt',
    instagram: 'Instagram',
    copyright: 'Alle Rechte vorbehalten.',
  },
};